module.exports = __webpack_public_path__ + "img/auth3.a3809fd5.png";